/* Unaöd, scripts communs du thème : ajout au panier (tiroir de Dawn), apparition douce, message court */
(function () {
  const U = (window.Unaod = window.Unaod || {});

  // Ajout au panier : une ou plusieurs lignes [{ id: variantId, quantity }], puis ouverture du tiroir panier de Dawn
  U.add = async function (items, opts = {}) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) { U.toast(data.description || data.message || 'Ajout impossible'); return null; }
    if (drawer && data.sections) {
      drawer.classList.remove('is-empty');
      if (opts.silent) {
        // Ajout discret : on met à jour le tiroir et la bulle sans ouvrir le tiroir
        drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
        drawer.getSectionsToRender().forEach((sec) => {
          const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
          if (el && data.sections[sec.id]) el.innerHTML = drawer.getSectionInnerHTML(data.sections[sec.id], sec.selector);
        });
      } else {
        drawer.renderContents(Object.assign({}, data, { id: items[0].id }));
      }
    } else if (!drawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'unaod', cartData: data });
    if (opts.silent) U.toast(opts.message || 'Ajouté au panier');
    return data;
  };

  // Boutons simples : <button data-u-add="VARIANT_ID" data-u-qty="1">
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-u-add]');
    if (!b) return;
    e.preventDefault();
    const items = b.dataset.uAdd.split(',').map((id) => ({ id: +id, quantity: +(b.dataset.uQty || 1) }));
    b.setAttribute('aria-busy', 'true');
    const ok = await U.add(items, { silent: b.hasAttribute('data-u-silent'), message: b.dataset.uMessage });
    b.removeAttribute('aria-busy');
    if (ok && b.hasAttribute('data-u-reload')) { location.reload(); return; }
    if (ok && b.classList.contains('u-card__add')) {
      const html = b.innerHTML;
      b.classList.add('is-done');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span class="u-card__add-t">Ajouté</span>';
      setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = html; }, 1600);
    }
  });

  // 03/11/2026, piste 1 : « Passez au coffret » du tiroir. Retire un exemplaire du soin puis ajoute le coffret, seulement au clic.
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-u-upgrade]');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.dataset.key, quantity: +b.dataset.qty || 0 })
      });
      if (!r.ok) throw new Error('change');
      const ok = await U.add([{ id: +b.dataset.id, quantity: 1 }], {});
      if (ok && b.hasAttribute('data-u-reload')) { location.reload(); return; }
    } catch (err) { U.toast('Remplacement impossible, réessayez.'); }
    b.removeAttribute('aria-busy');
  });

  // Message court en bas de l'écran
  let t;
  U.toast = function (msg) {
    let el = document.querySelector('.u-toast');
    if (!el) { el = document.createElement('div'); el.className = 'u-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(t); t = setTimeout(() => el.classList.remove('is-on'), 2200);
  };

  // Prix en euros à partir de centimes
  U.euros = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';

  // Apparition douce des blocs
  const watch = () => {
    const els = document.querySelectorAll('.u-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  };
  document.addEventListener('DOMContentLoaded', watch);
  document.addEventListener('shopify:section:load', watch);
})();
